/**
 * @generated SignedSource<<63a5351e98bf7ba692812beb6a422fd0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReassignPhaseSignoffApproverInput = {
  psaMilestoneId: string;
  approverPortalUserId: string;
  reason: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type reassignPhaseSignoffApproverMutation$variables = {
  input: ReassignPhaseSignoffApproverInput;
};
export type reassignPhaseSignoffApproverMutation$data = {
  readonly reassignPhaseSignoffApprover: {
    readonly phase: {
      readonly id: string;
      readonly portalConfig: {
        readonly signoffRequestApproverPortalUserId: string | null;
      } | null;
    } | null;
  } | null;
};
export type reassignPhaseSignoffApproverMutation = {
  variables: reassignPhaseSignoffApproverMutation$variables;
  response: reassignPhaseSignoffApproverMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ReassignPhaseSignoffApproverPayload",
    "kind": "LinkedField",
    "name": "reassignPhaseSignoffApprover",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PhaseType",
        "kind": "LinkedField",
        "name": "phase",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhasePortalConfig",
            "kind": "LinkedField",
            "name": "portalConfig",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signoffRequestApproverPortalUserId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "reassignPhaseSignoffApproverMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "reassignPhaseSignoffApproverMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8d42aa8a5e50639fa195f3a807a07cf0",
    "id": null,
    "metadata": {},
    "name": "reassignPhaseSignoffApproverMutation",
    "operationKind": "mutation",
    "text": "mutation reassignPhaseSignoffApproverMutation(\n  $input: ReassignPhaseSignoffApproverInput!\n) {\n  reassignPhaseSignoffApprover(input: $input) {\n    phase {\n      id\n      portalConfig {\n        signoffRequestApproverPortalUserId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55ea289a7ff326e43cc75226ee13613d";

export default node;
